import type { App } from 'vue'
import i18n from '@/services/languages/i18n'
export default function (app: App) {
  app.use(i18n)
}
